import { defineStore } from 'pinia'
import { api } from '@/api'
import { setTimeZone, setMomentLocale } from '../utils/countryConfig'

export const useRescheduleStore = defineStore('reschedule', {
  state: () => ({
    appointmentId: null,
    processId: null,
    pageLang: null,
    pageCountry: null,
    appointmentDetails: {},
    getAppointmentDetailsBusy: true,
    appointmentExpired: false,
    appointmentTypeId: null,
    subUnitId: null,
    serviceId: null,
    unitName: null,
    currentDate: null,
    meetingLang: '',
    documentType: '',
    documentNumber: '',
    customerType: '',
    childrenCount: null,
  }),

  actions: {
    updateLanguage(value) {
      this.pageLang = value
    },
    updateCountry(value) {
      this.pageCountry = value
    },
    updateProcessId(value) {
      this.processId = value
    },
    updateAppointmentId(value) {
      this.appointmentId = value
    },
    async getAppointmentDetails({ appointmentId, processId, pageLang, pageCountry }) {
      this.getAppointmentDetailsBusy = true
      try {
        const response = await api.getAppointmentDetails(appointmentId, processId, pageLang, pageCountry)
        this.getAppointmentDetailsBusy = false

        if (response.data.error) {
          this.appointmentExpired = true
          return
        }
        const data = response.data.appointment
        this.appointmentTypeId = data.appointment_type.id
        this.subUnitId = data.unit.id
        this.serviceId = data.service_id
        this.unitName = data.unit.name
        this.meetingLang = data.meeting_lang
        this.documentType = data.document_type
        this.documentNumber = data.document_number
        this.customerType = data.group
        setMomentLocale(this.pageLang)
        let timeStamp = response.data.appointment.date
        let date = setTimeZone(timeStamp, this.pageCountry)
        this.currentDate = date

        this.appointmentDetails = data
        if (this.appointmentDetails.customer.children) {
          this.childrenCount = this.appointmentDetails.customer.children.length
        }
      } catch (error) {
        this.getAppointmentDetailsBusy = false
        if (error) {
          this.appointmentExpired = true
          return
        }
      }
    },
  },
})
